var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard7Spades(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 309.4 427.3",
    style: {
      enableBackground: "new 0 0 309.4 427.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6EEF4;}\n\t.st1{clip-path:url(#SVGID_00000172417677660320804620000001224330466391156096_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.7,0h-280C6.6,0,0,6.6,0,14.7v397.9c0,8.1,6.6,14.7,14.7,14.7h280c8.1,0,14.7-6.6,14.7-14.7V14.7 C309.5,6.6,302.9,0,294.7,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.8,274.3L176.8,274.3c0,0,37,37,66.3-7.4c15.3-23.1,4.9-45.6-11.4-61.1l-70-69c-3.9-3.4-10-3.4-13.9,0l-71.1,69 c-14,14.6-25.9,38-10.4,61.1c29.5,44.2,66.3,7.4,66.3,7.4c0,18.9-5.4,43.2-6.9,49.8c-0.2,0.9,0.5,1.8,1.5,1.8h55.2 c1,0,1.7-0.8,1.4-1.8C182.2,317.5,176.8,293.1,176.8,274.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7,36.9c4.1,0,7.4-3.3,7.4-7.4c0-4.1-3.3-7.4-7.4-7.4H29.5c-4.1,0-7.4,3.3-7.4,7.4c0,4.1,3.3,7.4,7.4,7.4H73.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8,29.5c0-4.1-3.3-7.4-7.4-7.4S22,25.4,22,29.5v7.4c0,4.1,3.3,7.4,7.4,7.4s7.4-3.3,7.4-7.4V29.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9,102c-0.7,4,2,7.8,6,8.5s7.8-2,8.5-6C56.5,74,62.3,59.8,79.7,33.7c2.3-3.4,1.3-8-2-10.2s-8-1.3-10.2,2 C49,53.2,42.4,69.4,36.9,102z"
  })), /*#__PURE__*/React.createElement("g", null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M289.4,370.5c0,20.3-16.5,36.8-36.8,36.8s-36.8-16.5-36.8-36.8c0-20.3,16.5-36.8,36.8-36.8S289.4,350.1,289.4,370.5z  M252.6,340c-16.8,0-30.4,13.6-30.4,30.4s13.6,30.4,30.4,30.4s30.4-13.6,30.4-30.4S269.4,340,252.6,340z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M277.3,363.7c0,6.5-5.7,12.4-12.8,12.4c-7.2-0.3-12.8-5.9-12.8-12.4c0-6.5,5.7-12.2,12.8-12.4 C271.6,351.5,277.3,357.1,277.3,363.7z M272.2,363.7c0-4.2-3.5-7.6-7.8-7.6c-4.3,0-7.8,3.4-7.8,7.6s3.5,7.6,7.8,7.6 C268.7,371.2,272.2,367.9,272.2,363.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M261.6,386.7c0,3.5-3,6.3-6.9,6.5c-3.8,0-6.9-3-6.9-6.5c0-3.5,3.1-6.5,6.9-6.5C258.5,380.4,261.6,383.2,261.6,386.7z  M257.4,386.7c0-1.4-1.2-2.6-2.6-2.6c-1.5,0-2.6,1.1-2.6,2.6s1.2,2.6,2.6,2.6C256.2,389.3,257.4,388.2,257.4,386.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M244.7,359.9c-1.6,0-3,1.3-3,2.8c0,1.5,1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8C247.7,361.1,246.3,359.9,244.7,359.9z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M234.8,379.8c-1.6,0-3,1.3-3,2.8s1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8S236.4,379.8,234.8,379.8z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M270.6,383.5c-1.6,0-3,1.3-3,2.8c0,1.5,1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8C273.5,384.8,272.2,383.5,270.6,383.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 252.6,
    cy: 370.5,
    r: 30.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000074421038917978615120000014208588934368922774_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000074421038917978615120000014208588934368922774_)"
    },
    d: "M242,350.7c-0.2,3.5-3.4,6.2-7.2,6 c-3.8-0.2-6.7-3.4-6.4-6.9c0.2-3.5,3.4-6.3,7.2-6.1C239.3,344.2,242.2,347.3,242,350.7z M237.7,350.5c0.1-1.4-1-2.6-2.5-2.7 c-1.5-0.1-2.7,1-2.8,2.4c-0.1,1.4,1,2.6,2.5,2.7C236.4,353,237.7,351.9,237.7,350.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard7Spades);
export default __webpack_public_path__ + "static/media/card_7-spades.f5479b660d8db4a32a390e72b1c5bbc9.svg";
export { ForwardRef as ReactComponent };